<div class="flex flex-col gap-4 p-4">
  <div class="flex justify-between items-center">
    <div></div>
    <app-button
      label="Nueva receta"
      icon="bi bi-plus-lg"
      variant="success"
      (onClick)="modal_crear_producto.set(true)"
    />
  </div>

  <app-tabla [datos]="recetas()" [columnas]="columnasTabla" [accionesTemplate]="acciones">
    <ng-template #acciones let-item>
      <div class="flex gap-2 justify-center">
        <app-button
          icon="bi bi-pencil"
          variant="info"
          rounded
          size="sm"
          appTooltip="Editar"
          tooltipPosition="bottom"
          (onClick)="onEditar(item)"
        />
        <app-button
          icon="bi bi-copy"
          variant="info"
          rounded
          size="sm"
          appTooltip="Duplicar"
          tooltipPosition="bottom"
          (onClick)="onDuplicar(item)"
        />
        <app-button
          icon="bi bi-trash"
          variant="danger"
          rounded
          size="sm"
          appTooltip="Eliminar"
          tooltipPosition="bottom"
          (onClick)="solicitarEliminar(item)"
        />
      </div>
    </ng-template>

    <ng-template #costoTemplate let-item>
      {{ item.costo_estimado | currency: 'S/ ' : 'symbol' : '1.2-2' }}
    </ng-template>
    <ng-template #precioVentaTemplate let-item>
      {{ item.producto_receta_precio_venta | currency: 'S/ ' : 'symbol' : '1.2-2' }}
    </ng-template>
    <ng-template #margenTemplate let-item>
      @if (item.producto_receta_precio_venta > 0) {
        <span
          [class.text-green-600]="item.producto_receta_precio_venta - item.costo_estimado > 0"
          [class.text-red-500]="item.producto_receta_precio_venta - item.costo_estimado <= 0"
        >
          {{
            ((item.producto_receta_precio_venta - item.costo_estimado) /
              item.producto_receta_precio_venta) *
              100 | number: '1.1-1'
          }}%
        </span>
      }
    </ng-template>
    <ng-template #ingredientesTemplate let-item>
      <span class="text-sm">{{ item.detalles?.length || 0 }} ingredientes</span>
    </ng-template>
    <ng-template #activoTemplate let-item>
      @if (item.activo) {
        <span class="text-green-600 font-medium">Activo</span>
      } @else {
        <span class="text-red-500 font-medium">Inactivo</span>
      }
    </ng-template>
  </app-tabla>

  @if (recetas().length === 0) {
    <div class="text-center text-gray-500 py-8">
      <i class="bi bi-journal-x text-4xl block mb-2"></i>
      <p>No hay recetas. Crea tu primera receta.</p>
    </div>
  }
</div>

<!-- Modal Crear Producto + Receta -->
<app-dialog
  header="Nuevo producto (Receta)"
  [modal]="true"
  [(visible)]="modal_crear_producto"
  size="3xl"
  styleClass="max-w-[750px]"
  (onHide)="modal_crear_producto.set(false)"
>
  @if (modal_crear_producto()) {
    <app-crear-producto
      [categorias]="categorias()"
      [tipoInicial]="etipoReceta"
      (crear)="onProductoCreado()"
      (cerrar)="modal_crear_producto.set(false)"
    />
  }
</app-dialog>

<!-- Modal Editar -->
<app-dialog
  header="Editar receta"
  [modal]="true"
  [(visible)]="modal_editar"
  size="4xl"
  (onHide)="modal_editar.set(false)"
>
  @if (recetaSeleccionada()) {
    <app-receta-form
      [receta]="recetaSeleccionada()"
      [modoEdicion]="true"
      (onGuardar)="onCerrarEditar($event)"
      (onCancelar)="onCerrarEditar()"
    />
  }
</app-dialog>

<!-- Modal Duplicar -->
<app-dialog
  header="Duplicar receta"
  [modal]="true"
  [(visible)]="modal_duplicar"
  size="4xl"
  (onHide)="modal_duplicar.set(false)"
>
  @if (recetaSeleccionada()) {
    <app-receta-form
      [receta]="recetaSeleccionada()"
      [modoDuplicar]="true"
      (onGuardar)="onCerrarDuplicar($event)"
      (onCancelar)="onCerrarDuplicar()"
    />
  }
</app-dialog>

<!-- Modal Eliminar -->
<app-dialog
  header="Eliminar receta"
  [modal]="true"
  [(visible)]="modal_eliminar"
  size="xs"
  (onHide)="cerrarModalEliminar()"
>
  <app-modal-confirmacion
    [mensaje]="'¿Estás seguro de eliminar la receta ' + (recetaAEliminar()?.nombre ?? '') + '?'"
    textoCancel="Cancelar"
    textoConfirm="Eliminar"
    (confirmar)="eliminar()"
    (cancelar)="cerrarModalEliminar()"
  />
</app-dialog>
